import React from 'react';
import { remCss } from 'src/helpers';

const Download2 = React.memo(
  ({
    fill = 'red',
    rx = 5,
    fillOpacity = 1,
    stroke = 'white',
    width = 24,
    viewBox = '0 0 24 24',
    viewSize = 24,
    outline = false
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={remCss(width)}
      height={remCss((width * 50) / 24)}
      viewBox={viewBox}
    >
      <rect
        width={viewSize - (outline ? 1 : 0)}
        height={viewSize - (outline ? 1 : 0)}
        fill={fill}
        rx={rx}
        fillOpacity={fillOpacity}
      />
      <path
        d='M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 17L12 21M12 21L16 17M12 21V12'
        stroke={stroke}
        fill={'transparent'}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
);
Download2.displayName = 'Download2';

export default Download2;
